const initAccountFlyout = () => {
  const html = document.querySelector("html")
  const body = document.body
  const account_flyout_togglers = document.querySelectorAll(
    ".account-flyout-toggler"
  )

  // CLICK EVENT - [".account-flyout-toggler"] - Close the account flyout
  account_flyout_togglers.forEach((el) =>
    el.addEventListener("click", function () {
      html.classList.remove("disable-scrolling")
      body.classList.remove("account-flyout-active")
    })
  )

  // CLICK EVENT - ["a[href*='/account']"] - Open the account flyout instead of navigating to /account
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a[href]")

    if (!link) return
    if (link.closest(".account-flyout")) return
    if (/^\/account(\/|$)/.test(window.location.pathname)) return

    let url

    try {
      url = new URL(link.href, window.location.origin)
    } catch (err) {
      return
    }

    if (url.origin !== window.location.origin) return
    if (!/^\/account\/?($|\/(login|register)(\/|$))/.test(url.pathname)) return

    e.preventDefault()
    html.classList.add("disable-scrolling")
    body.classList.add("account-flyout-active")
  })

  // KEYDOWN EVENT - ["Escape"] - Close the account flyout
  document.addEventListener("keydown", function (e) {
    if (
      e.key === "Escape" &&
      body.classList.contains("account-flyout-active")
    ) {
      html.classList.remove("disable-scrolling")
      body.classList.remove("account-flyout-active")
    }
  })
}

document.addEventListener("DOMContentLoaded", initAccountFlyout)
